import { GenericLazyString } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import React from 'react';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { WaypointLazyRender } from '../../../../components/WaypointLazyRender';

const CategoryEventsContainer = loadable(
    () => import('./CategoryEventsContainer'),
);
interface CategoryEventsProps {
    queryOverload?: OrganicEventSearchFiltersApiPayload;
    categoryKey?: string;
    categoryTitle?: string | GenericLazyString;
    viewMore?: string | GenericLazyString;
    categoryIcon?: JSX.Element;
    bucketPosition?: number;
}
export const LazyCategoryEventBucket = ({
    queryOverload,
    categoryKey,
    categoryTitle,
    viewMore,
    categoryIcon,
    bucketPosition,
}: CategoryEventsProps) => {
    return (
        <WaypointLazyRender
            bottomOffset="-300px"
            emptyStateStyles={{ height: '300px' }}
        >
            <CategoryEventsContainer
                queryOverload={queryOverload}
                categoryTitle={categoryTitle}
                categoryKey={categoryKey}
                categoryIcon={categoryIcon}
                viewMore={viewMore}
                bucketPosition={bucketPosition}
            />
        </WaypointLazyRender>
    );
};
